<template>
  <div class="loading-dots-wrapper">
    <div class="loading-dots">
      <span class="dot">.</span>
      <span class="dot">.</span>
      <span class="dot">.</span>
    </div>
  </div>
</template>

<style scoped>
.loading-dots-wrapper {
  padding: 4px;
  position: relative;
  width: 32px;
  height: 42px;
}

.loading-dots {
  position: absolute;
  width: 100%;
  height: 100%;
}

.dot {
  position: absolute;
  font-size: 42px;
  animation: blink 1.4s infinite both;
}

.dot:nth-child(1) {
  left: 0;
  animation-delay: 0s;
}

.dot:nth-child(2) {
  left: 40%;
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  left: 80%;
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0.2;
    transform: scale(1);
  }
  20% {
    opacity: 1;
    transform: scale(0.5);
  }
  100% {
    opacity: 0.2;
    transform: scale(1);
  }
}
</style>
